/* StackSchematic mark, used when the sidebar is collapsed. */
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: { width: 'auto', height: 28 },
  mark: { fill: 'none', stroke: '#22B8CF', strokeWidth: 7, strokeLinejoin: 'round', strokeLinecap: 'round' },
  node: { fill: '#22B8CF' },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return (
    <svg className={classes.svg} viewBox="0 0 88 90" xmlns="http://www.w3.org/2000/svg">
      <g className={classes.mark}>
        <path d="M12 26 L44 10 L76 26 L44 42 Z" />
        <path d="M12 45 L44 61 L76 45" />
        <path d="M12 62 L44 78 L76 62" />
      </g>
      <circle className={classes.node} cx="44" cy="26" r="5" />
    </svg>
  );
};
